import React, {Component} from 'react';
import {UncontrolledTooltip} from "reactstrap";
import {deepCopyObject} from "../../../helper/helper";
import moment from "moment";
import Datetime from "react-datetime";
import {validateComponent, validateField} from "../../../common/validation";
import Select from "../../../local_node_modules/react-select";
import {request} from "../../../helper/APIUtils";

class NewCustomaryPriceListItems extends Component {

    constructor(props) {
        super(props);
        this.state = {
            listPrices: this.props.listPrices,
            error:{},
            erpTypes: this.props.erpTypes,
            selectedCustomerBranches: [],
            connectorTypes: [],
            serviceTypes: this.props.serviceTypes,
            selectedServiceTypes: [],
            servicePrice: [],
            progressRate: [],
            branchName: [],
            existingInstallationPrice: false,
            installationPriceList: []
        };

        this.validateClass =  this.validateClass.bind(this);
        this.validateField =  this.validateField.bind(this);
        this.validateMessage =  this.validateMessage.bind(this);
        this.checkDateValidity =  this.checkDateValidity.bind(this);
        this.handleEditDates = this.handleEditDates.bind(this);
        this.validateComponent =   this.validateComponent.bind(this);
        this.getErpType = this.getErpType.bind(this);
        this.serviceTypes = this.serviceTypes.bind(this);
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength && e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    componentDidMount() {
        const connectorTypes = [
            { value: 1, label: "Connector Standart" },
            { value: 2, label: "Connector Plus" }
        ];
        this.setState({ connectorTypes: connectorTypes });
    }

    handleServiceTypeChange = (selectedServiceType, index) => {
        const updatedListPrices = [...this.state.listPrices];
        updatedListPrices[index].servicePrice = selectedServiceType.price;
        this.setState({ listPrices: updatedListPrices });
    };

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let self=this;
        let result = validateComponent(self);
        this.setState({
            error: result.error
        });
        return result
    }

    checkDateValidity(index,current, name) {
        let listPrices = deepCopyObject(this.state.listPrices);
        let copyCurrent = current.clone();
        if (name === 'startDate') {
            return moment(copyCurrent).isValid;
        }
        if (name === 'expireDate') {
            return copyCurrent.isAfter(listPrices[index].startDate);
        }
    }

    handleEditDates(index, event, type) {
        let listPrices = deepCopyObject(this.state.listPrices);

        if (type === 'startDate') {
            if (!(typeof event === "string")) {
                let startDate = event.format("YYYY-MM-DD");
                let finishDate = event.clone().add(1, 'years').format('YYYY-MM-DD');

                listPrices[index].startDate=startDate;
                listPrices[index].finishDate=finishDate;
                this.setState({listPrices});
            }
        } else {
            if (!(typeof selection === "string")) {
                let finishDate = event.format("YYYY-MM-DD");
                listPrices[index].finishDate=finishDate;
                this.setState({listPrices});
            }
        }

    }

    handleProgressRateChange = (e, index) => {
        let value = e.target.value;
        value = value.replace(/,/g, '.');
        let numericValue = value;

        if (value === "" || !isNaN(value)) {
            numericValue = value;
        } else {
            numericValue = "";
        }
        this.setState(prevState => {
            const updatedProgressRate = [...prevState.progressRate];
            updatedProgressRate[index] = numericValue;
            return { progressRate: updatedProgressRate };
        });
    };

    handleBlur = (index) => {
        this.validateField({
            target: {
                id: "progressRate_" + index,
                dataset: {
                    'vdata': "smallerThanOrEquals",
                    'vlength': "1.00"
                },
                value: this.state.progressRate[index]
            }
        });
    };

    getBranchName(value){
        let branchNameInfos = null;
        branchNameInfos = this.props.customer.customerBranchList.find(item => item.recordId === value);
        return branchNameInfos ? { value: branchNameInfos.recordId, label: branchNameInfos.branchName } : null;
    }

    updateBranchName(index, selectedOption) {
        const branch = this.props.customer.customerBranchList.find(
            branch => branch.recordId === selectedOption.value
        );

        if (branch) {
            const updatedInstallationPriceList = [...this.state.installationPriceList];
            updatedInstallationPriceList[index] = {
                ...updatedInstallationPriceList[index],
                branchId: branch.recordId,  // value olarak recordId
                branchName: branch.branchName // branchName'i filtre sonucu alıyoruz
            };

            this.setState({ installationPriceList: updatedInstallationPriceList });
        }
    }


    updateServicePrice = (index, e) => {
        const newValue = e.target.value;

        const numericValue = isNaN(newValue) ? "" : parseFloat(newValue).toFixed(0);
        this.setState(prevState => {
            const updatedServicePrices = [...prevState.servicePrice];
            updatedServicePrices[index] = numericValue;
            return { servicePrice: updatedServicePrices };
        });
    };

    handleCustomerBranchChange = (index, selectedOption) => {
        const updatedBranches = [...this.state.selectedCustomerBranches];
        updatedBranches[index] = selectedOption;
        this.setState({ selectedCustomerBranches: updatedBranches});
    };

    handleConnectorTypeChange = (index, selectedOption) => {
        const updatedTypes = [...this.state.connectorTypes];
        updatedTypes[index] = selectedOption;
        this.setState({ connectorTypes: updatedTypes });
    };

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.listPrices !== this.props.listPrices)
        {
            this.setState({listPrices : nextProps.listPrices});
        }
    }

    getErpType(value){
        let erpLabel = null;
        erpLabel = this.state.erpTypes.find(item => item.value === value);
        return erpLabel
    }

    getServiceType(value){
        let serviceLabel = null;
        serviceLabel = this.state.serviceTypes.find(item => item.value === value);
        return serviceLabel
    }

    serviceTypes() {
        return [
            {
                label: "Fatura",
                value: 1
            },
            {
                label: "E-Defter",
                value: 3
            },
            {
                label: "E-Irsaliye",
                value: 6
            },
            {
                label: "E-MM",
                value: 8
            },
            {
                label: "E-Mühasebe",
                value: 13
            },
            {
                label: "Kurulum Ücreti",
                value: 12
            },
        ];
    }


    render() {
        const connectorType = [
            { value: 1 , label: "Connector Standart"},
            { value: 2 , label: "Connector Plus"}
        ];

        const {listPrices} = this.state;

        return (
            <div>
                <div className="col-sm-12" >
                    <div className="tab-content">
                        <div>
                            <div>
                                <table className="" style={{textAlign: 'center', paddingBottom: "5px", width:"100%"}}>
                                    <thead>
                                    <tr style={{backgroundColor: '#ebedf0'}}>
                                        <th width="3%">#</th>
                                        <th width="12%">Konnektör Türü</th>
                                        <th width="12%">Hizmet Türü</th>
                                        <th width="12%">Hizmet Ücreti</th>
                                        <th width="10%">Hakediş Oranı</th>
                                        <th width="17%">Başlangıç Tarihi</th>
                                        <th width="17%">Bitiş Tarihi</th>
                                        <th width="10%">İşlem</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {listPrices && listPrices.map((item, index) =>
                                        <tr key={index}>
                                            <td data-label={"#"}>{(index + 1).toString()}</td>
                                            <td data-label={"Konnektör Türü"}>
                                                <div
                                                    className={"form-group" + this.validateClass("connectorType_" + index)}
                                                    style={{
                                                        marginLeft: "3px",
                                                        marginRight: "3px",
                                                        width: "130px"
                                                    }}>
                                                    <Select
                                                        id={'connectorType_' + index}
                                                        name={"connectorType"}
                                                        value={item.connectorType}
                                                        clearable={false}
                                                        noResultsText="Sonuç bulunmadı"
                                                        placeholder="Konnektör Türü Seçiniz..."
                                                        style={{width: "130px"}}
                                                        options={connectorType}
                                                        onChange={(selectedOption) => {
                                                            this.props.onChangeNumber({
                                                                value: selectedOption.value,
                                                                name: "connectorType"
                                                            }, index, this.props.name)
                                                            // this.handleConnectorTypeChange(index, selectedOption)
                                                        }}
                                                    />
                                                    {this.validateMessage("connectorType_" + index) !== "" &&
                                                        <UncontrolledTooltip placement="right"
                                                                             target={"connectorType_" + index}
                                                                             delay={0}>
                                                            {this.validateMessage("connectorType_" + index)}
                                                        </UncontrolledTooltip>}
                                                </div>
                                            </td>

                                            <td data-label={"Hizmet Türü"}>{<div
                                                className={"form-group" + this.validateClass("serviceType_" + index)}>
                                                <Select id={'serviceType_' + index}
                                                        name={"serviceType"}
                                                        value={this.getServiceType(item.serviceType)}
                                                        clearable={false}
                                                        placeholder={"Hizmet Türü Seçiniz"}
                                                        ref={'serviceType_' + index}
                                                        onChange={(e) => {
                                                            this.props.onChangeNumber({
                                                                value: e.value,
                                                                name: "serviceType"
                                                            }, index, this.props.name);
                                                        }}
                                                        onBlur={() => this.validateField({
                                                            target: {
                                                                id: "serviceType_" + index,
                                                                dataset: {
                                                                    'vdata': "required",
                                                                    'vlength': "1,100"
                                                                },
                                                                value: item.serviceType
                                                            }
                                                        })}
                                                        style={{width: "100px"}}
                                                        options={this.state.serviceTypes}
                                                        inputProps={{'vdata': "required", 'vlength': "1,255"}}/>
                                                {this.validateMessage("serviceType_" + index) !== "" &&
                                                    <UncontrolledTooltip placement="right"
                                                                         target={"serviceType_" + index} delay={0}>
                                                        {this.validateMessage("serviceType_" + index)}
                                                    </UncontrolledTooltip>}</div>}
                                            </td>

                                            <td data-label={"Hizmet Ücreti"}>{<div
                                                className={"form-group" + this.validateClass("servicePrice_" + index)}>
                                                <input
                                                    value={item.servicePrice}
                                                    name={"servicePrice"}
                                                    type="text"
                                                    placeholder=""
                                                    onChange={(e) => {
                                                        this.props.onChangeNumber({
                                                            value: e.target.value,
                                                            name: "servicePrice"
                                                        }, index, this.props.name)
                                                        // this.updateServicePrice(index, e)
                                                    }}
                                                    style={{width: "75px"}}
                                                />
                                                {this.validateMessage("servicePrice_" + index) !== "" &&
                                                    <UncontrolledTooltip placement="right"
                                                                         target={"servicePrice_" + index}
                                                                         delay={0}>
                                                        {this.validateMessage("servicePrice_" + index)}
                                                    </UncontrolledTooltip>}</div>}
                                            </td>

                                            <td data-label={"Hakediş Oranı"}>{<div
                                                className={"form-group" + this.validateClass("progressRate_" + index)}>
                                                <input
                                                    id={'progressRate_' + index}
                                                    name={"progressRate"}
                                                    value={item.progressRate}
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Oran Giriniz"
                                                    style={{width: "70px"}}
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace(',', '.');
                                                        this.props.onChangeNumber({
                                                            value: value,
                                                            name: "progressRate"
                                                        }, index, this.props.name)
                                                    }}
                                                    onBlur={() => this.handleBlur(index)}
                                                />
                                                {this.validateMessage("progressRate_" + index) !== "" &&
                                                    <UncontrolledTooltip placement="right"
                                                                         target={"progressRate_" + index} delay={0}>
                                                        {this.validateMessage("progressRate_" + index)}
                                                    </UncontrolledTooltip>}</div>}</td>

                                            <td data-label={"Başlangıç Tarihi"}>{<div
                                                style={{
                                                    marginLeft: "3px",
                                                    marginRight: "3px",
                                                    width: "70px"
                                                }}
                                                className={"form-group" + this.validateClass("tStartDate_" + index)}>
                                                <Datetime locale="tr"
                                                          id={"tStartDate_" + index}
                                                          className="datepicker"
                                                          input={true}
                                                          inputProps={{
                                                              id: 'tStartDate_' + index,
                                                              dataset: {
                                                                  vdata: "date",
                                                                  vlength: "1,255",
                                                                  value: item.startDate
                                                              }
                                                          }}
                                                          onBlur={(momentObj) => this.validateField({
                                                              target: {
                                                                  id: 'tStartDate_' + index,
                                                                  dataset: {
                                                                      'vdata': "required",
                                                                      'vlength': "1,255"
                                                                  },
                                                                  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
                                                              }
                                                          })}
                                                          closeOnSelect={true}
                                                          value={item.startDate ? moment(item.startDate).format('DD-MM-YYYY') : null}
                                                          dateFormat="DD-MM-YYYY"
                                                          ref={"tStartDate_" + index}
                                                          isValidDate={(current) => this.checkDateValidity(index, current, 'startDate')}
                                                          timeFormat={false}
                                                          onChange={(e) => this.props.handleEditDates(index, e, 'startDate', this.props.name)}
                                                />
                                                {this.validateMessage("tStartDate_" + index) !== "" &&
                                                    <UncontrolledTooltip placement="right"
                                                                         target={"tStartDate_" + index} delay={0}>
                                                        {this.validateMessage("tStartDate_" + +index)}
                                                    </UncontrolledTooltip>}
                                            </div>}</td>
                                            <td data-label={"Bitiş Tarihi"}>{<div
                                                style={{
                                                    marginLeft: "3px",
                                                    marginRight: "3px",
                                                    width: "70px"
                                                }}
                                                className={"form-group" + this.validateClass("tExpireDate_" + index)}>
                                                <Datetime locale="tr"
                                                          id={"tExpireDate_" + index}
                                                          className="datepicker"
                                                          input={true}
                                                          inputProps={{
                                                              id: 'tExpireDate_' + index,
                                                              dataset: {
                                                                  vdata: "date",
                                                                  vlength: "1,255",
                                                                  value: item.expireDate
                                                              }
                                                          }}
                                                          onBlur={(momentObj) => this.validateField({
                                                              target: {
                                                                  id: "tExpireDate_" + index,
                                                                  dataset: {
                                                                      'vdata': "required",
                                                                      'vlength': "1,255"
                                                                  },
                                                                  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
                                                              }
                                                          })}
                                                          closeOnSelect={true}
                                                          value={item.expireDate ? moment(item.expireDate).format('DD-MM-YYYY') : null}
                                                          dateFormat="DD-MM-YYYY"
                                                          ref={"tExpireDate_" + index}
                                                          isValidDate={(current) => this.checkDateValidity(index, current, 'expireDate')}
                                                          timeFormat={false}
                                                          onChange={(e) => this.props.handleEditDates(index, e, 'expireDate', this.props.name)}
                                                />
                                                {this.validateMessage("tExpireDate_" + index) !== "" &&
                                                    <UncontrolledTooltip placement="right"
                                                                         target={"tExpireDate_" + index} delay={0}>
                                                        {this.validateMessage("tExpireDate_" + index)}
                                                    </UncontrolledTooltip>}
                                            </div>}</td>
                                            <td data-label={"İşlemler"}>
                                                <button type="button"
                                                        onClick={() => this.props.handleRemove(index, this.props.name)}
                                                        disabled={(this.props.name !== "customaryPriceList") && listPrices.length < 2}
                                                        data-toggle="tooltip" data-placement="bottom"
                                                        title="Sil"
                                                        style={{background: 'linear-gradient(#ff3636b8, #ff3636b8)'}}
                                                        rel="tooltip" className="Btn btn-sm btn-icon">
                                                    <i className="fa fa-trash"/>
                                                </button>
                                            </td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                                <button type="button" onClick={() => this.props.addNewLine(this.props.name)}
                                        disabled={this.props.isLoading}
                                        style={{
                                            background: ' linear-gradient(rgb(134 193 243), #1085d8)',
                                            padding: '9px 45px 9px 20px'
                                        }}
                                        className="TekBtn ekle">Satır Ekle
                                </button>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default NewCustomaryPriceListItems;